module.exports = __webpack_public_path__ + "img/shopping-cart-add.0156eee1.svg";